import React, {useEffect, useRef, useCallback, useState} from 'react'
import { useDrag, useDragDropManager } from 'react-dnd'

// Class is untested do not use. 

function useAccessibleDrag (props) {
    const KEYCODE = {
        DOWN: 40,
        LEFT: 37,
        RIGHT: 39,
        SPACE: 32,
        UP: 38
    }
    const {item} = props
    const [collection, refCallback, preview] = useDrag(props)
    const dndManager = useDragDropManager()
    const {beginDrag, endDrag, hover, drop} = dndManager.getActions()
    const monitor = dndManager.getMonitor()
    const dragRef = useRef(null)
    const [target, setTarget] = useState(null)
    const findDragId = () => {
        const hasHandlerId = dragRef.current.hasAttribute('data-handler-id')
        if (hasHandlerId) {
            const test = dragRef.current.getAttribute('data-handler-id').split('_').at(0)
            return test
        }

        // Old way of finding the dragId
        const dragSources = monitor.registry.dragSources
        if (dragSources.size === 0) return null
        const newItem = dragSources.reduce((pre,cur,index) =>{
            if(pre) return pre
            if(cur.spec.item.data.k === item.data.k) return cur

        },null)
        if (newItem === null) return null
        return newItem?.monitor.sourceId
    }
    const setDragRef = useCallback (node => {
        dragRef.current = node.current || node
        return refCallback(node)
    },[])


    useEffect(() => {
        if(!dragRef.current?.addEventListener) return
        dragRef.current.addEventListener('keydown', keyDown);
        dragRef.current.addEventListener('focus', focus);
        dragRef.current.addEventListener('blur', blur);
        return () => {
            dragRef.current.removeEventListener('keydown', keyDown);
            dragRef.current.removeEventListener('focus', focus);
            dragRef.current.removeEventListener('blur', blur);
        }
    })

    const keyDown = (event) => {

        const type = event.type;
        let next;
        if(type === "keydown"){
            const id = findDragId()
            switch (event.keyCode) {
                case KEYCODE.DOWN:
                case KEYCODE.RIGHT:
                    next = nextTarget()
                    break;
                case KEYCODE.UP:
                case KEYCODE.LEFT:
                    next = previousTarget()
                    break;
                case KEYCODE.SPACE:
                    next = id;
                    // TODO: update DnD Manager to drop
                    !!monitor.isDragging() && drop()
                    !!monitor.isDragging() && endDrag()
                    // TODO: update DnD Manager to endDrag
                    // TODO: update DnD Manager to beginDrag
                    // TODO: may need to give new item focus if it changed location in DOM
                    break;
                default:
                    break
            }
            if (next) {
                event.preventDefault();
                event.stopPropagation();
                // TODO: update sr-only for selection
                // TODO: update DnD Manager to hover the next target
            }
        }
    }
    const focus = (event)=>{
        // To avoid adding focus multiple times
        if(!event.target.classList.contains('focus')){
            event.currentTarget.className += ' focus';
        }
        const dragId = findDragId()
        // Apparently double !! is needed to make sure it is a boolean
        !!!monitor.isDragging() && dragId && beginDrag([dragId])
        // TODO: update DnD Manager to beginDrag
    }
    const blur = (event)=> {
        event.currentTarget.className = event.currentTarget.className.replace(' focus','');
        !!monitor.isDragging() && endDrag()
        // TODO: update DnD Manager to endDrag
    }
    const getTargets = () => {
        let validTargets
        if(monitor.registry.dropTargets.size > 0){
           validTargets =[]
            monitor.registry.dropTargets.mapKeys((item, index)=>{
               if (monitor.canDropOnTarget(index) && item.spec.zone.dragId === undefined) validTargets.push(index)
            })
        }
        return validTargets       
    }
    const nextTarget = (data,value=undefined)=>{
        const targets = getTargets()
        if(targets.length === 0) return
        let newTarget, currentTarget
        if(!target){
            newTarget = targets[0]
        } else {
            currentTarget = targets.findIndex(e => e === target)
            if (currentTarget < targets.length - 1){
                newTarget = targets[currentTarget+1]
            } else {
                newTarget = targets[0]
            }
        }
        setTarget(newTarget)
        hover([newTarget])
    }
    const previousTarget = (data,value=undefined)=>{
        const targets = getTargets()
        if(targets.length === 0) return
        let newTarget, currentTarget
        if(!target){
            newTarget = targets[targets.length-1]
        } else {
            currentTarget = targets.findIndex(e => e === target)
            if (currentTarget === 0){
                newTarget = targets[targets.length-1]
            } else {
                newTarget = targets[currentTarget-1]
            }
        }
        setTarget(newTarget)
        hover([newTarget])
    }

    return [collection, setDragRef, preview]
}

export default useAccessibleDrag